'use client';

import { c as _c } from "react/compiler-runtime";
import type { Budget } from '@/modules/finances/types';
import { QueryClientProvider } from '@/modules/shared/providers/query-client';
import { ReservesWaterfallChartInternal } from './reserves-waterfall-chart-internal/reserves-waterfall-chart-internal';
interface ReservesWaterfallChartProps {
  codePath: string;
  budgets: Budget[];
  allBudgets: Budget[];
  year: string;
}
function ReservesWaterfallChart(t0) {
  const $ = _c(6);
  const {
    codePath,
    budgets,
    allBudgets,
    year
  } = t0;
  const key = `${codePath}-${year}`;
  let t1;
  if ($[0] !== allBudgets || $[1] !== budgets || $[2] !== codePath || $[3] !== key || $[4] !== year) {
    t1 = <QueryClientProvider><ReservesWaterfallChartInternal key={key} codePath={codePath} budgets={budgets} allBudgets={allBudgets} year={year} /></QueryClientProvider>;
    $[0] = allBudgets;
    $[1] = budgets;
    $[2] = codePath;
    $[3] = key;
    $[4] = year;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}
export { ReservesWaterfallChart };